module.exports = __webpack_public_path__ + "img/Balanceakt.e12bffed.jpg";